import type { AnimationI, AnySceneObjectT } from "tweenly"
import { selectAllAnimations } from "./selectAllAnimations"

export const selectAnimationById = (objects: AnySceneObjectT[], id: string): AnimationI => {
    const allAnimations = selectAllAnimations(objects)
    return allAnimations.find((x) => x.id === id)!
}
